import React from 'react';
import ModalVideo from 'react-modal-video';
import { graphql, useStaticQuery } from 'gatsby';

const VideoModal = ({ isOpen, onClose }) => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        video_id
      }
    }
  `);

  const {
    strapiHomePage: { video_id },
  } = data;

  return (
    <>
      <ModalVideo
        channel='youtube'
        isOpen={isOpen}
        videoId={`${video_id}`}
        onClose={onClose}
      />
    </>
  );
};

export default VideoModal;
